import { gql } from '@apollo/client';

export const COMPANY_NEWS_LIST = gql`
  query CompanyNewsList($input: CompanyNewsListInput, $page: Int, $first: Int) {
    companyNewsList(input: $input, page: $page, first: $first) {
      data {
        active
        content
        created_at
        id
        image
        link {
          url
          label
        }
        publication_period {
          from
          until
        }
        title
        updated_at
      }
      paginatorInfo {
        count
        currentPage
        lastPage
      }
    }
  }
`;

export const CREATE_COMPANIES_NEWS = gql`
  mutation CreateCompanyNews($input: CreateNewsArticleInput!) {
    createCompanyNews(input: $input) {
      id
    }
  }
`;

export const DELETE_COMPANIES_NEWS = gql`
  mutation DeleteCompanyNews($deleteCompanyNewsId: ID!) {
    deleteCompanyNews(id: $deleteCompanyNewsId) {
      id
    }
  }
`;

export const UPDATE_COMPANIES_NEWS = gql`
  mutation UpdateCompanyNews(
    $updateCompanyNewsId: ID!
    $input: UpdateNewsArticleInput!
  ) {
    updateCompanyNews(id: $updateCompanyNewsId, input: $input) {
      id
    }
  }
`;

export const GET_COMPANY_NEWS_FROM_ID = gql`
  query CompanyNewsArticle($companyNewsArticleId: ID!) {
    companyNewsArticle(id: $companyNewsArticleId) {
      active
      content
      id
      image
      created_at
      link {
        url
        label
      }
      publication_period {
        until
        from
      }
      title
    }
  }
`;
